import { render, staticRenderFns } from "./CustomerOrthoArch.vue?vue&type=template&id=0ba53d12"
import script from "./CustomerOrthoArch.vue?vue&type=script&lang=js"
export * from "./CustomerOrthoArch.vue?vue&type=script&lang=js"
import style0 from "./CustomerOrthoArch.vue?vue&type=style&index=0&id=0ba53d12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports